import type { FC } from 'react';

import { getStoreValue } from 'pixel-react';
import { Outlet, Navigate } from 'react-router-dom';

export const ProtectedRoute: FC = () => {
  const token = getStoreValue('auth_token');

  return !token ? <Navigate to="/login" /> : <Outlet />;
};
